export const SET_NAME = (payload)=> {
  return {
    type: 'SET_NAME',
    payload,
  }
}
export const SET_MESSAGE = (payload)=> {
  return {
    type: 'SET_MESSAGE',
    payload,
  }
}
export const SET_NOTICE = (payload)=> {
  return {
    type: 'SET_NOTICE',
    payload,
  }
}
export const SET_CRM_ACCOUNT_ID = (payload)=> {
  return {
    type: 'SET_CRM_ACCOUNT_ID',
    payload,
  }
}
export const CLEAR_MESSAGE = (payload)=> {
  return {
    type: 'CLEAR_MESSAGE',
    payload,
  }
}
export const CLEAR_NOTICE = (payload)=> {
  return {
    type: 'CLEAR_NOTICE',
    payload,
  }
}